import type { Statuses } from "@callcenter/shared-types"
import { UiState } from "@callcenter/shared-types"

import { getStatusColor, statusColors } from "@callcenter-frontend/style"

export const defineUiStatusColor = (state: UiState, status: Statuses) => {
  if (state === UiState.away && ["int-out-ringing", "int-out-talk", "int-in-ringing", "int-in-talk"].includes(status)) {
    return statusColors.away
  }

  return getStatusColor(status)
}
